module.exports = __webpack_public_path__ + "static/media/PostNord.294e492b.svg";